import { useMutation, useQueryClient } from 'react-query'
import { api } from '../api'
import { ProjectFormRevisionNumberValues } from 'shared'
import { ApiUrlEnum } from '../../enums/ApiUrlEnum'
import { QueryKeyEnum } from '../../enums/QueryKeyEnum'

export const useSetProjectFormHeaderFooterMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ project, projectFormType, revisionNumber }: ProjectFormRevisionNumberValues) =>
      api.post(`${ApiUrlEnum.PROJECT_FORM_HEADER_FOOTER}/${project}/${projectFormType}`, {
        revisionNumber,
        project,
        projectFormType,
      }),
    mutationKey: [QueryKeyEnum.PROJECT_FORM_HEADER_FOOTER],
    onSuccess: () => {
      return queryClient.invalidateQueries([QueryKeyEnum.PROJECT_FORM_HEADER_FOOTER])
    },
  })
}
